export default {"src":"/_next/static/media/CommentsTjRed.704a6aa3.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};